/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q3_CInputs */

const en_consult_q3_c = /** @type {(inputs: Consult_Q3_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still gathering information`)
};

const id_consult_q3_c = /** @type {(inputs: Consult_Q3_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masih kumpulkan informasi`)
};

/**
* | output |
* | --- |
* | "Still gathering information" |
*
* @param {Consult_Q3_CInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q3_c = /** @type {((inputs?: Consult_Q3_CInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q3_CInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q3_c(inputs)
	return en_consult_q3_c(inputs)
});